import { Screen } from '~/screens/Admins/new';

export const AdminsNew: React.FC = () => <Screen />;
